import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Sprint } from 'types';

type UpdateSprintPayload = {
  sprintId: string;
  name?: string;
  goal?: string;
  startDate?: string;
  endDate?: string;
  issueIds?: string[];
  status?: 'planned' | 'active' | 'completed';
};

const updateSprint = async (payload: UpdateSprintPayload): Promise<Sprint> => {
  const { sprintId, ...body } = payload;
  const response = (await customAxios.patch<Sprint>(
    `/sprints/${sprintId}`,
    body
  )) as { data: Sprint };
  return response.data;
};

export const useUpdateSprint = () => {
  const queryClient = useQueryClient();

  return useMutation(updateSprint, {
    onSuccess: (data) => {
      queryClient
        .invalidateQueries(['projects', data.project, 'sprints'])
        .catch(() => undefined);
    },
  });
};
